import { render } from "./PropertiesYAxisTimestamp.vue?vue&type=template&id=2ea3b3a2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__